export default "__VITE_ASSET__R9Av5Cwt__"